export default {
  priv: 'pr_device',
  overviewTitle: 'Status Aanpassingen',
  url: '/devices/statusupdates',
  apiUrl: '/devicestatusupdates/',
  sortBy: ['created_timestamp'],
  sortDesc: [true],
  addRecord: false,
  deletable: false,
  editable: false,
  filterName: 'devicestatusupdates',
  quickFilter: {
    text: 'Zoeken',
    value: 'report_code_serial_nr',
    type: 'text'
  },
  advancedSearchFields: [
    {
      text: 'Rapport of camera bevat',
      value: 'report_code_serial_nr',
      type: 'text'
    },
    {
      text: 'Toezichter',
      value: 'supervisor_id',
      type: 'optionList',
      optionListName: 'supervisors'
    },
    {
      text: 'Periode van',
      value: 'date_start',
      type: 'date'
    },
    {
      text: 'Periode tot',
      value: 'date_end',
      type: 'date'
    },
    {
      text: 'Afgehandeld',
      value: 'state',
      type: 'optionList',
      optionList: [
        {
          value: 0,
          text: 'Nee'
        },
        {
          value: 1,
          text: 'Ja'
        }
      ]
    }
  ],
  tableFields: [
    {
      text: 'Rapport',
      value: 'report_code',
      width: '20%',
      link: '/devices/measurereports/{devicereport_id}'
    },
    {
      text: 'Camera',
      value: 'serial_nr',
      width: '12.5%'
    },
    {
      text: 'Datum',
      value: 'created_timestamp',
      width: '12.5%',
      filter: 'date'
    },
    {
      text: 'Beschrijving',
      value: 'description',
      width: '15%'
    },
    {
      text: 'Toezichter',
      value: 'supervisor_name',
      width: '20%'
    },
    {
      text: 'Actie EMT',
      value: 'action_emt',
      filter: 'boolean-string',
      align: 'center',
      sortable: false,
      width: '7.5%'
    },
    {
      text: 'Afgehandeld',
      value: 'state',
      filter: 'boolean',
      align: 'center',
      sortable: false,
      width: '7.5%'
    }
  ]
};
